// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep mat-card.battery-strings-card {
  padding: 0;
}
::ng-deep mat-card.battery-strings-card mat-card-content {
  padding: 16px;
  margin: 0;
}

.battery-id-duplicate ::ng-deep .mat-form-field-outline,
.battery-id-duplicate ::ng-deep .mat-form-field-outline-thick,
.battery-id-duplicate ::ng-deep .mat-form-field-label {
  color: var(--color-error, #f44336);
}
.battery-id-duplicate ::ng-deep input {
  color: var(--color-error, #f44336);
}

.duplicate-hint {
  color: var(--color-error, #f44336);
}

.battery-strings-form {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 16px;
}
.battery-strings-form .form-field {
  width: 100%;
}

.modules-section {
  display: flex;
  gap: 24px;
  margin-top: 16px;
  align-items: flex-start;
}
.modules-section .modules-input-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 220px;
}
.modules-section .modules-input-col .modules-label {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-normal);
  color: rgba(0, 0, 0, 0.6);
}
.modules-section .modules-input-col .modules-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}
.modules-section .modules-input-col .modules-controls .module-field {
  flex: 1;
}
.modules-section .modules-list-col {
  flex: 1;
}
.modules-section .modules-list-col .module-table {
  width: 100%;
  border-collapse: collapse;
}
.modules-section .modules-list-col .module-table .module-row {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.modules-section .modules-list-col .module-table .module-row .module-index {
  color: rgba(0, 0, 0, 0.54);
  font-size: var(--font-size-small);
  width: 32px;
  padding: 4px 8px;
}
.modules-section .modules-list-col .module-table .module-row .module-value {
  padding: 4px 8px;
  font-family: monospace;
}
.modules-section .modules-list-col .module-table .module-row .module-remove {
  width: 40px;
  text-align: right;
}

.card-header {
  display: grid;
  grid-template-columns: 1fr 180px 40px;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background-color: var(--panel-color-default);
}
.card-header .section-label {
  font-family: var(--font-family-default);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-normal);
  line-height: 24px;
  color: var(--brand-color-main);
}
.card-header .battery-select {
  width: 180px;
  margin: 0;
}
.card-header .action-button-slot {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/battery-strings/battery-strings.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AACI;EACI,aAAA;EACA,SAAA;AACR;;AAII;;;EAGI,kCAAA;AADR;AAII;EACI,kCAAA;AAFR;;AAMA;EACI,kCAAA;AAHJ;;AAMA;EACI,aAAA;EACA,qCAAA;EACA,aAAA;AAHJ;AAKI;EACI,WAAA;AAHR;;AAOA;EACI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAMI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAJR;AAMQ;EACI,mCAAA;EACA,sCAAA;EACA,yBAAA;AAJZ;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AALZ;AAOY;EACI,OAAA;AALhB;AAUI;EACI,OAAA;AARR;AAUQ;EACI,WAAA;EACA,yBAAA;AARZ;AAUY;EACI,4CAAA;AARhB;AAUgB;EACI,0BAAA;EACA,iCAAA;EACA,WAAA;EACA,gBAAA;AARpB;AAWgB;EACI,gBAAA;EACA,sBAAA;AATpB;AAYgB;EACI,WAAA;EACA,iBAAA;AAVpB;;AAiBA;EACI,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,4CAAA;AAdJ;AAgBI;EACI,uCAAA;EACA,iCAAA;EACA,sCAAA;EACA,iBAAA;EACA,8BAAA;AAdR;AAiBI;EACI,YAAA;EACA,SAAA;AAfR;AAkBI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBR","sourcesContent":["::ng-deep mat-card.battery-strings-card {\n    padding: 0;\n\n    mat-card-content {\n        padding: 16px;\n        margin: 0;\n    }\n}\n\n.battery-id-duplicate {\n    ::ng-deep .mat-form-field-outline,\n    ::ng-deep .mat-form-field-outline-thick,\n    ::ng-deep .mat-form-field-label {\n        color: var(--color-error, #f44336);\n    }\n\n    ::ng-deep input {\n        color: var(--color-error, #f44336);\n    }\n}\n\n.duplicate-hint {\n    color: var(--color-error, #f44336);\n}\n\n.battery-strings-form {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px 16px;\n\n    .form-field {\n        width: 100%;\n    }\n}\n\n.modules-section {\n    display: flex;\n    gap: 24px;\n    margin-top: 16px;\n    align-items: flex-start;\n\n    .modules-input-col {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        min-width: 220px;\n\n        .modules-label {\n            font-size: var(--font-size-default);\n            font-weight: var(--font-weight-normal);\n            color: rgba(0, 0, 0, 0.6);\n        }\n\n        .modules-controls {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n\n            .module-field {\n                flex: 1;\n            }\n        }\n    }\n\n    .modules-list-col {\n        flex: 1;\n\n        .module-table {\n            width: 100%;\n            border-collapse: collapse;\n\n            .module-row {\n                border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n                .module-index {\n                    color: rgba(0, 0, 0, 0.54);\n                    font-size: var(--font-size-small);\n                    width: 32px;\n                    padding: 4px 8px;\n                }\n\n                .module-value {\n                    padding: 4px 8px;\n                    font-family: monospace;\n                }\n\n                .module-remove {\n                    width: 40px;\n                    text-align: right;\n                }\n            }\n        }\n    }\n}\n\n.card-header {\n    display: grid;\n    grid-template-columns: 1fr 180px 40px;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 16px;\n    background-color: var(--panel-color-default);\n\n    .section-label {\n        font-family: var(--font-family-default);\n        font-size: var(--font-size-large);\n        font-weight: var(--font-weight-normal);\n        line-height: 24px;\n        color: var(--brand-color-main);\n    }\n\n    .battery-select {\n        width: 180px;\n        margin: 0;\n    }\n\n    .action-button-slot {\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
